import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

export const DEPARTMENT_CREATE_RESOURCE = "department" as const;
export const DEPARTMENT_CREATE_API_PATH = `/v1/${DEPARTMENT_CREATE_RESOURCE}` as const;

export type DepartmentCreateBody =
  paths[typeof DEPARTMENT_CREATE_API_PATH]["post"]["requestBody"]["content"]["application/json"];
export type DepartmentCreateResponse =
  paths[typeof DEPARTMENT_CREATE_API_PATH]["post"]["responses"][200]["content"]["application/json"];

export const useDepartmentCreateMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<DepartmentCreateResponse, Error, DepartmentCreateBody>({
    mutationFn: async (department: DepartmentCreateBody) => {
      const response = await alphartisApiAxios.post<DepartmentCreateResponse>(DEPARTMENT_CREATE_API_PATH, department);
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [DEPARTMENT_CREATE_RESOURCE],
      });
    },
  });
};
